module.exports = __webpack_public_path__ + "img/greentick.6bfaa03c.svg";